import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';

import { Text } from '../common';
import phoneAppImg from '../../../images/phone_graphic.png';

export default function DownloadAppModal(props) {
  const { isOpen, onRequestClose } = props;
  const modalStyles = {
    content: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#0EA5E9',
    },
  };
  return (
    <Modal
      style={modalStyles}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={true}
    >
      <Text
        color="white"
        fontSize="base"
        clickable
        style={{ position: 'absolute', top: 12, right: 18 }}
        onClick={onRequestClose}
      >
        X
      </Text>
      <Wrapper>
        <PhoneBlock src={phoneAppImg} />
        <TextBlock>
          <Text color="white" fontSize="5xl" fontWeight="bold" textAlign="center">
            DOWNLOAD
          </Text>
          <Text
            color="white"
            fontSize="5xl"
            fontWeight="bold"
            textAlign="center"
            style={{ marginTop: -18 }}
          >
            the app to:
          </Text>
          <ul style={{ marginTop: 25 }}>
            <li style={{ color: 'white', margin: 20 }}>
              <Text color="white" fontSize="2xl">
                Create an account
              </Text>
            </li>
            <li style={{ color: 'white', margin: 20 }}>
              <Text color="white" fontSize="2xl">
                List an item
              </Text>
            </li>
            <li style={{ color: 'white', margin: 20 }}>
              <Text color="white" fontSize="2xl">
                Book a rental
              </Text>
            </li>
            <li style={{ color: 'white', margin: 20 }}>
              <Text color="white" fontSize="2xl">
                Chat with owners
              </Text>
            </li>
            <li style={{ color: 'white', margin: 20 }}>
              <Text color="white" fontSize="2xl">
                and more!
              </Text>
            </li>
          </ul>
          <Text
            color="white"
            textAlign="center"
            clickable
            style={{ marginTop: 30, textDecoration: 'underline' }}
            onClick={onRequestClose}
          >
            continue to site
          </Text>
        </TextBlock>
      </Wrapper>
    </Modal>
  );
}

const Wrapper = styled.div`
  display: flex;
`;

const PhoneBlock = styled.div`
  background-image: ${(p) => `url('${p.src}');`}
  width: 330px;
  height: 505px;
  background-size: contain;
  background-repeat: no-repeat;
  margin-bottom: -18px;
`;

const TextBlock = styled.div`
  width: 300px;
  padding-top: 40px;
`;



// WEBPACK FOOTER //
// ./src/components_new/DownloadAppModal/index.js